module.exports = __webpack_public_path__ + "src/img/pcNum.43fdc630.png";